import React from "react";
import { useResume } from "../../data/dataCtx";

const Contact = ()=> {
    const resume = useResume();
    console.log(resume)
    return (
        <section className="py-5">
        <div className="container px-5">
            {/* <!-- Contact form--> */}
            <div className="bg-light rounded-4 py-5 px-4 px-md-5">
                <div className="text-center mb-5">
                    <div className="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 mb-3"><i className="bi bi-envelope"></i></div>
                    <h1 className="fw-bolder">Get in touch</h1>
                    <p className="lead fw-normal text-muted mb-0">Let's work together!</p>
                </div>
                <div className="row gx-5 justify-content-center">
                   {resume?.main?.contact.map(({image,url},i)=>(
                        <a key={i} target="__blank" href={url} style={{alignContent:'center',alignItems:'center',justifyContent:'center'}} className="col-sm-12 col-md-4 d-flex">
                            <img style={{maxWidth:"60%",maxHeight:"100%"}} src={image} alt="..."/>
                        </a>
                   ))}
                </div>
            </div>
        </div>
    </section>
    )
}

export default Contact;